import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=4ad2ba0a&scoped=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"
import style0 from "./Company.vue?vue&type=style&index=0&id=4ad2ba0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad2ba0a",
  null
  
)

export default component.exports